const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_OaN4IKWnP',
      userPoolClientId: '1p644c5qpbprshs4a7qd08sqff',
      userPoolRegion: 'us-east-1',
    }
  }
};

export default awsConfig;